<template>
  <md-app md-mode='fixed'>
    <md-app-toolbar class="md-primary">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
            <md-icon>menu</md-icon>
          </md-button>
          <h3 class="md-title">Team</h3>
        </div>
        <div class="md-toolbar-section-end">
          <md-menu md-align-trigger>
            <md-avatar v-if="user && user.avatar" md-menu-trigger>
              <img :src="user.avatar" alt="People">
            </md-avatar>
            <md-menu-content>
              <Profile />
            </md-menu-content>
          </md-menu>
        </div>
      </div>
    </md-app-toolbar>
    <md-app-drawer :md-active.sync="menuVisible">
      <md-toolbar class="md-transparent" md-elevation="0">Navigation</md-toolbar>

      <md-list>
        <md-list-item>
          <md-icon>book</md-icon>
          <span class="md-list-item-text">Handbook</span>
        </md-list-item>

        <md-list-item>
          <md-icon>message</md-icon>
          <span class="md-list-item-text">Notification</span>
        </md-list-item>

        <md-list-item>
          <md-icon>check-circle-outline</md-icon>
          <span class="md-list-item-text">Checklist</span>
        </md-list-item>

        <md-list-item>
          <md-icon>group</md-icon>
          <span class="md-list-item-text">Team</span>
        </md-list-item>
      </md-list>
    </md-app-drawer>
    <md-app-content>
      <router-view/>
    </md-app-content>
  </md-app>
</template>
<script>
import { mapState } from 'vuex'
import Profile from '@/components/Profile.vue'
export default {
  name: "Admin",
  components: {
    Profile
  },
  data (){
    return {
      menuVisible: false
    }
  },
  computed: {
    ...mapState({
      user: s => s.auth.user
    })
  }
}
</script>
<style lang="scss">
.md-avatar{
  margin-right: 0;
}
.md-app {
  min-height: 100%;
}
</style>
